module.exports = __webpack_public_path__ + "static/media/sitka-harbor-bg.4239094c.jpeg";